import { BindAll } from 'lodash-decorators'
import type { CityTypeInfo } from '@xt/client/entities/kindred-spirit/kindred-spirit'
import { $service } from '@xt/client/experimental/request/service'
import { EnumApiTonghao } from '@xt/client/api/kindred-spirit'
import { action, observable, computed } from 'mobx'

@BindAll()
export class Cities {
  constructor() {}

  /** 分桐模块
   * 1.根据定位获取对应城市的分桐信息 */

  // 获取定位推荐城市
  public async getLocateCities(locate?): Promise<Array<CityTypeInfo> | void> {
    if (!locate) return

    const [, data] = await $service<Array<CityTypeInfo>>({
      url: EnumApiTonghao.RecommendCitys,
      data: {
        locate
      }
    })

    if (Array.isArray(data) && data.length > 0) {
      return data
    }

    return []
  }

  // 获取推荐分桐
  public async getRecommendCities(): Promise<Array<CityTypeInfo>> {
    const [, data] = await $service<Array<CityTypeInfo>>({
      url: EnumApiTonghao.RecommendCitys,
      data: {}
    })

    if (Array.isArray(data) && data.length > 0) {
      return data
    }

    return []
  }

  // 桐学会城市列表页 - 获取已创建的城市列表
  public async getCreatedCityList() {}
}
